import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export abstract class ApiService {
    protected httpClient: HttpClient;

    protected defaultHeaders = new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    });

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    /* tslint:disable:no-bitwise */
    /**
     * Split a bits number into it's enum values
     * @param value Bit values.
     * @param type Target enum type.
     */
    protected splitEnums<TEnum>(value: number, type: TEnum): any[] {
        const values: TEnum[] = [];
        while (value) {
            const bit = value & (~value + 1);
            values.push(type[bit]);
            value ^= bit;
        }

        return values;
    }
    /* tslint:enable:no-bitwise */

    /**
     * Combine multiple enum values in a bits number.
     * @param values Enum values.
     * @param type Target enum type.
     */
    protected combineEnums<TEnum>(values: any[], type: TEnum): number {
        let n = 0;
        for (const value of values) {
            n += type[value];
        }

        return n;
    }
}
